import { generatePath, useHistory } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import {
  useNetworkHomeJobsRouteParams,
  useNetworkOrgId,
  useCurrentHomeSiteId,
} from 'features/networkAi/hooks'
import { subscriptionPricesSelector } from 'features/home'
import { useAppSelector } from 'app/hooks'
import {
  fetchClaimDevicesThunk,
  fetchInventoryThunk,
} from 'features/networkAi/slice'
//import { Price } from 'features/home/types'
import {
  subscribedAccessPointsSelector,
  claimDevicesFetchDataSelector,
} from 'features/networkAi/selectors'
import { fetchSubscriptionPricesSliceThunk } from 'features/home/components/HomeSubscription/SubscriptionDetails/slice'
import ROUTES from 'app/routes'
import { useIntl } from 'react-intl'
import { makePublicUrl } from 'app/utils/publicUrl'
import { CommonButton } from 'components/Button'
import { networkStatusMessages } from './messages'
import { network } from 'features/networkAi/messages'
import { purchaseSubscriptionMessages } from 'features/networkAi/NetworkWizard/PurchaseDeviceSubscription/messages'
import {
  NetworkStatusSubscriptionBody,
  NetworkStatusSubscriptionContainer,
  NetworkStatusSubscriptionHeader,
  NetworkStatusSubscriptionHeaderMoreButton,
  NetworkStatusSubscriptionHeaderTitle,
  NetworkStatusSubscriptionSubscribe,
  NetworkStatusSubscriptionSubscribeTitleIcon,
  NetworkStatusSubscriptionSubscribeTitle,
  NetworkStatusSubscriptionSubscribeTitleContainer,
  NetworkStatusSubscriptionSubscribeItem,
  NetworkStatusSubscriptionItemHeader,
  NetworkStatusSubscriptionItemBody,
  NetworkStatusSubscriptionItemFooter,
  NetworkStatusSubscriptionSubscribeIcon,
  NetworkStatusSubscriptionForwardIcon,
  NetworkStatusSubscriptionForwardButton,
  NetworkStatusSubscriptionItemLeft,
  NetworkStatusSubscriptionItemRight,
  NetworkStatusSubscriptionSubCount,
  NetworkStatusSubscriptionSubCountLabel,
  NetworkStatusSubscriptionClaimedCount,
  SubRemainingStatus,
} from './styles'
import { SpinnerCentered } from 'components/Loader'
import SubsriptionStatusInformation from 'features/networkAi/NetworkWizard/SubscriptionStatusDashboard/SubsriptionStatusInformation'
import { InviteAdminToSite } from './NetworkInviteAdmin'
import { hasSubscriptionPermissionSelector } from 'features/auth/permissions/selectors'
import { subscriptionStatusSelector } from 'features/home/selectors'

function NetworkStatusSubscription() {
  const history = useHistory()
  const dispatch = useDispatch()
  const { formatMessage } = useIntl()

  const organizationId = useNetworkOrgId()
  const { rootDomainId, jobId, homeId } = useNetworkHomeJobsRouteParams()
  const siteId = useCurrentHomeSiteId({ homeId })
  const hasSubscriptionPermission = useAppSelector(
    hasSubscriptionPermissionSelector
  )

  //const hostMachineType = useAppSelector(homeHostMachineTypeSelector)

  useEffect(() => {
    dispatch(fetchSubscriptionPricesSliceThunk(homeId))
  }, [dispatch, homeId])

  InviteAdminToSite(organizationId, siteId)

  const isPriceLoaded = useAppSelector(subscriptionPricesSelector.isFinished)
  const claimDevices = useAppSelector(claimDevicesFetchDataSelector.data)
  const subscribedAccessPoints = useAppSelector(subscribedAccessPointsSelector)
  const renewingStatus = useAppSelector(
    subscriptionStatusSelector(1, subscribedAccessPoints.count)
  )

  const [showClaimButton, setShowClaimButton] = useState(false)

  useEffect(() => {
    if (siteId) dispatch(fetchClaimDevicesThunk(siteId))
    if (organizationId) dispatch(fetchInventoryThunk(siteId))
  }, [dispatch, siteId, organizationId])

  useEffect(() => {
    if (
      claimDevices !== null &&
      subscribedAccessPoints.count > claimDevices?.length
    ) {
      setShowClaimButton(true)
    }
  }, [claimDevices, subscribedAccessPoints])

  const handleCreateNewNetworkClick = () => {
    if (siteId !== '') {
      const pathname = generatePath(
        ROUTES.networkAi.wizard.purchaseSubscription,
        {
          rootDomainId,
          jobId,
          homeId,
        }
      )
      history.push(pathname)
    } else {
      const pathname = generatePath(ROUTES.networkAi.wizard.root, {
        rootDomainId,
        jobId,
        homeId,
      })
      history.push(pathname)
    }
  }

  const handleNavigateAPsClick = () => {
    const pathname = generatePath(ROUTES.networkAi.dashboard.accessPoints, {
      rootDomainId,
      jobId,
      homeId,
    })
    history.push(pathname)
  }

  function formatTimestamp(timestamp: number | null) {
    try {
      if (timestamp !== null) {
        const milliseconds = timestamp
        const dateObject = new Date(milliseconds)
        const humanDateFormat = dateObject.toLocaleDateString()
        return humanDateFormat
      } else {
        return '-'
      }
    } catch (e) {
      console.log(e)
      return timestamp
    }
  }

  return (
    <>
      {!isPriceLoaded ? (
        <SpinnerCentered size="40" />
      ) : (
        <>
          <NetworkStatusSubscriptionContainer>
            <NetworkStatusSubscriptionHeader>
              <NetworkStatusSubscriptionHeaderTitle>
                Subscription Status
              </NetworkStatusSubscriptionHeaderTitle>
              <NetworkStatusSubscriptionHeaderMoreButton
                onClick={() => {}}
                disabled
              ></NetworkStatusSubscriptionHeaderMoreButton>
            </NetworkStatusSubscriptionHeader>

            <NetworkStatusSubscriptionBody>
              <NetworkStatusSubscriptionSubscribe>
                <NetworkStatusSubscriptionSubscribeTitleContainer>
                  <NetworkStatusSubscriptionSubscribeTitleIcon
                    src={makePublicUrl(`images/networkIcons/router.svg`)}
                  />
                  <NetworkStatusSubscriptionSubscribeTitle>
                    {formatMessage(network.title)}
                  </NetworkStatusSubscriptionSubscribeTitle>
                </NetworkStatusSubscriptionSubscribeTitleContainer>

                {siteId !== '' &&
                  subscribedAccessPoints.count !== 0 &&
                  subscribedAccessPoints.count !== undefined && (
                    <>
                      <NetworkStatusSubscriptionItemFooter>
                        <NetworkStatusSubscriptionItemLeft>
                          {subscribedAccessPoints.autoRenew !== null
                            ? formatMessage(
                                networkStatusMessages.subRenewalTitle
                              )
                            : formatMessage(
                                networkStatusMessages.subExpireTitle
                              )}
                        </NetworkStatusSubscriptionItemLeft>
                        <NetworkStatusSubscriptionItemRight>
                          {formatTimestamp(subscribedAccessPoints.expiresAt)}
                        </NetworkStatusSubscriptionItemRight>
                      </NetworkStatusSubscriptionItemFooter>

                      {renewingStatus !== undefined &&
                        renewingStatus.length === 4 &&
                        renewingStatus[2] !== renewingStatus[3] && (
                          <>
                            <NetworkStatusSubscriptionItemFooter>
                              <NetworkStatusSubscriptionItemLeft>
                                APs Renewing
                              </NetworkStatusSubscriptionItemLeft>
                              <NetworkStatusSubscriptionItemRight>
                                {renewingStatus[3]}
                              </NetworkStatusSubscriptionItemRight>
                            </NetworkStatusSubscriptionItemFooter>
                          </>
                        )}
                    </>
                  )}

                <CommonButton
                  variant={
                    subscribedAccessPoints.count === undefined ||
                    subscribedAccessPoints.count === 0
                      ? 'primary'
                      : 'secondary'
                  }
                  onClick={handleCreateNewNetworkClick}
                  disabled={
                    !hasSubscriptionPermission
                  }
                >
                  {formatMessage(
                    subscribedAccessPoints.count === undefined ||
                      subscribedAccessPoints.count === 0
                      ? networkStatusMessages.noSubs
                      : networkStatusMessages.hasSubs
                  )}
                </CommonButton>
              </NetworkStatusSubscriptionSubscribe>

              <NetworkStatusSubscriptionSubscribeItem>
                <NetworkStatusSubscriptionItemHeader>
                  {siteId !== '' && (
                    <NetworkStatusSubscriptionForwardButton
                      onClick={handleNavigateAPsClick}
                    >
                      <NetworkStatusSubscriptionForwardIcon
                        src={makePublicUrl(
                          `images/networkIcons/arrow-forward.svg`
                        )}
                      />
                    </NetworkStatusSubscriptionForwardButton>
                  )}

                  {formatMessage(
                    purchaseSubscriptionMessages.accessPointsLabel
                  )}
                </NetworkStatusSubscriptionItemHeader>

                <NetworkStatusSubscriptionSubscribe>
                  <NetworkStatusSubscriptionItemBody>
                    <NetworkStatusSubscriptionSubscribeIcon
                      src={makePublicUrl(
                        `images/networkIcons/access-points.svg`
                      )}
                    />
                    <NetworkStatusSubscriptionItemBody>
                      {siteId !== '' && (
                        <>
                          <NetworkStatusSubscriptionClaimedCount>
                            {claimDevices?.length}{' '}
                          </NetworkStatusSubscriptionClaimedCount>
                          <NetworkStatusSubscriptionSubCountLabel>
                            {formatMessage(
                              networkStatusMessages.subClaimedText
                            )}
                          </NetworkStatusSubscriptionSubCountLabel>
                          <br />
                          <NetworkStatusSubscriptionSubCount>
                            {subscribedAccessPoints.count === undefined
                              ? 0
                              : subscribedAccessPoints.count}{' '}
                          </NetworkStatusSubscriptionSubCount>
                          <NetworkStatusSubscriptionSubCountLabel>
                            {formatMessage(
                              networkStatusMessages.subSubscribedText
                            )}
                          </NetworkStatusSubscriptionSubCountLabel>
                        </>
                      )}
                    </NetworkStatusSubscriptionItemBody>
                  </NetworkStatusSubscriptionItemBody>
                </NetworkStatusSubscriptionSubscribe>
              </NetworkStatusSubscriptionSubscribeItem>

              <NetworkStatusSubscriptionSubscribeItem disabled>
                <NetworkStatusSubscriptionItemHeader>
                  {formatMessage(purchaseSubscriptionMessages.switchesLabel)}
                </NetworkStatusSubscriptionItemHeader>

                <NetworkStatusSubscriptionItemBody>
                  <NetworkStatusSubscriptionSubscribeIcon
                    src={makePublicUrl(`images/networkIcons/switches.svg`)}
                  />
                </NetworkStatusSubscriptionItemBody>

                <NetworkStatusSubscriptionItemFooter>
                  {formatMessage(purchaseSubscriptionMessages.comingSoonLabel)}
                </NetworkStatusSubscriptionItemFooter>
              </NetworkStatusSubscriptionSubscribeItem>

              <NetworkStatusSubscriptionSubscribeItem disabled>
                <NetworkStatusSubscriptionItemHeader>
                  {formatMessage(purchaseSubscriptionMessages.wanEdgesLabel)}
                </NetworkStatusSubscriptionItemHeader>

                <NetworkStatusSubscriptionItemBody>
                  <NetworkStatusSubscriptionSubscribeIcon
                    src={makePublicUrl(`images/networkIcons/wan-edges.svg`)}
                  />
                </NetworkStatusSubscriptionItemBody>

                <NetworkStatusSubscriptionItemFooter>
                  {formatMessage(purchaseSubscriptionMessages.comingSoonLabel)}
                </NetworkStatusSubscriptionItemFooter>
              </NetworkStatusSubscriptionSubscribeItem>
            </NetworkStatusSubscriptionBody>
          </NetworkStatusSubscriptionContainer>

          {siteId !== '' &&
            subscribedAccessPoints.count !== 0 &&
            subscribedAccessPoints.count !== undefined && (
              <SubRemainingStatus>
                <div>&nbsp;</div>
                <SubsriptionStatusInformation
                  showClaimDeviceButton={showClaimButton}
                  claimedCount={claimDevices?.length || 0}
                  subscribedCount={subscribedAccessPoints.count}
                />
              </SubRemainingStatus>
            )}
        </>
      )}
    </>
  )
}

export default NetworkStatusSubscription
